import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Text } from '@wix/design-system';
import { Bookmark } from '../../../components/common/WixIcons';
import { ModalName } from '../../../constants/ModalName';
import { useModal } from '../../../utils/hooks/useModal';
import { Theme } from '../../../utils/hooks/useModal/useModal.types';
import styles from '../Root.scss';

export const useShutterstockDisabledModal = () => {
  const { formatMessage } = useIntl();
  return useModal(ModalName.ShutterstockDisabled, {
    theme: Theme.Destructive,
    title: formatMessage({ id: 'shutterstock-error-modal.title' }),
    content: (
      <Text>
        <FormattedMessage
          id="shutterstock-error-modal.content.boards"
          values={{
            bookmark: <Bookmark className={styles.shutterstockErrorIcon} />,
          }}
        />
      </Text>
    ),
    confirmText: formatMessage({ id: 'shutterstock-error-modal.confirm' }),
  });
};
